export const KEY_CODES = {
  TAB: 9,
  ENTER: 13,
  ESC: 27,
  LEFT_ARROW: 37,
  UP: 38,
  RIGHT_ARROW: 39,
  DOWN: 40
};